import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppBar, CssBaseline, Box, Grid, Toolbar, Typography } from '@material-ui/core';
import { Map as MapIcon } from '@material-ui/icons';
import Cookies from 'js-cookie';

import DashboardFilterBar from '../Commons/DashboardFilterBar/DashboardFilterBar';
import { updateFilterActionPayload } from '../state/DashboardFilterActions';
import { updateFilter, updateFilterType } from '../state/DashboardFilterState';
import { useStyles } from './GPSDevicesMapDashboardStyles';
import { MapSearch } from './MapSearch/MapSearch';

export default function GPSDevicesMapDashboard (): JSX.Element {
    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        //dispatch(updateFilterType({ filterType: 'range', excludeAverage: true }));
        const dashboardFilterCookie: updateFilterActionPayload = (Cookies.getJSON('dashboardFilter') as unknown as updateFilterActionPayload);

        if(dashboardFilterCookie) { 
            dispatch(updateFilter({ ...dashboardFilterCookie, excludeAverage: true, date: new Date(), dateTo: new Date()}));
        } else {
            dispatch(updateFilterType({ filterType: 'range', excludeAverage: true }));
        }
    }, []);

    return (
        <Box className={classes.root}>
            <CssBaseline />
            <AppBar className={classes.appBar} elevation={1} position="sticky" style={{paddingLeft:10}}>
                <Toolbar>
                    <Grid container spacing={2} justify="space-between" alignItems="center" alignContent="center">
                        <Grid item xs={12} md={12} lg={2} container alignItems="center" alignContent="center">
                            <MapIcon className={classes.icon} />
                            <Typography variant="h6" color="inherit" className={classes.title}>
                                GPS Devices
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={10} container justify="flex-end" alignItems="center" alignContent="center">
                            <Grid item xs={12}>
                                <DashboardFilterBar onApply={() => console.log('Filter is handled on other component nothing to do here')}  hideViewButton={true} hideTimer={true} hideFromDate={true} hideToDate={true}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <MapSearch />
        </Box>
    );
}
